"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TechnicalIndication = void 0;
const technical_indicator_enum_1 = require("../../@types/incoming/enum/technical-indicator.enum");
class TechnicalIndication {
    getIndication(data) {
        const readableIndicators = this.getReadableIndicators(data);
        return {
            results: readableIndicators,
            summary: this.getSummary(readableIndicators),
            internalPoints: this.getInternalPoints(readableIndicators),
        };
    }
    getReadableIndicators(indicators) {
        return [
            {
                id: 0,
                name: 'Indicador MACD (12,26)',
                value: indicators.MACD_12_26,
            },
            {
                id: 1,
                name: 'Índice de Direção de Movimento',
                value: indicators.ADX_14,
            },
            {
                id: 2,
                name: 'Índice de Força Relativa',
                value: indicators.RSI_14,
            },
            {
                id: 3,
                name: 'Oscilador Bulls Power',
                value: indicators.BULL_BEAR,
            },
            {
                id: 4,
                name: 'Indicador Momentum',
                value: indicators.ROC,
            },
            {
                id: 5,
                name: 'IFR Estocástico',
                value: indicators.STOCHRSI_14,
            },
            {
                id: 6,
                name: 'Oscilador Ultimate',
                value: indicators.ULTIMATE,
            },
            {
                id: 7,
                name: 'Média de Variação Verdadeira',
                value: indicators.ATR_14 > 4
                    ? technical_indicator_enum_1.eTechnicalIndicator.NEUTRAL
                    : indicators.ATR_14,
            },
            {
                id: 8,
                name: 'Williams %R Momento',
                value: indicators.WILLIAMS_R,
            },
            {
                id: 9,
                name: 'Indicador Estocástico (9,6)',
                value: indicators.STOCH_9_6,
            },
        ];
    }
    getSummary(readableIndications) {
        let qntBuy = 0;
        let qntSell = 0;
        let qntAlerts = 0;
        readableIndications.forEach((indication) => {
            switch (indication.value) {
                case technical_indicator_enum_1.eTechnicalIndicator.BUY:
                    return qntBuy++;
                case technical_indicator_enum_1.eTechnicalIndicator.SELL:
                    return qntSell++;
                case technical_indicator_enum_1.eTechnicalIndicator.STRONG_BUY:
                    return qntBuy++;
                case technical_indicator_enum_1.eTechnicalIndicator.STRONG_SELL:
                    return qntSell++;
                case technical_indicator_enum_1.eTechnicalIndicator.LESS_VOLATILITY:
                case technical_indicator_enum_1.eTechnicalIndicator.MORE_VOLATILITY:
                    return qntAlerts++;
            }
        });
        return {
            qntBuy,
            qntSell,
            qntAlerts,
        };
    }
    getInternalPoints(indicators) {
        let qntPoints = 0;
        indicators.forEach((indication) => {
            switch (indication.value) {
                case technical_indicator_enum_1.eTechnicalIndicator.BUY:
                    return qntPoints++;
                case technical_indicator_enum_1.eTechnicalIndicator.SELL:
                    return qntPoints--;
                case technical_indicator_enum_1.eTechnicalIndicator.STRONG_BUY:
                    qntPoints += 2;
                    break;
                case technical_indicator_enum_1.eTechnicalIndicator.STRONG_SELL:
                    qntPoints -= 2;
                    break;
            }
        });
        return qntPoints;
    }
}
exports.TechnicalIndication = TechnicalIndication;
//# sourceMappingURL=technical.indication.js.map